import { render, staticRenderFns } from "./PortfolioProductsListWithDetails.vue?vue&type=template&id=1e80fd7e"
import script from "./PortfolioProductsListWithDetails.vue?vue&type=script&lang=ts&scoped=true"
export * from "./PortfolioProductsListWithDetails.vue?vue&type=script&lang=ts&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports